import { Placeholders } from "../../../../constants/placeholders";
import { Roles } from "../../../../constants/roles";
import { snsPreviewManagerForm } from "../../sns-preview-manager-form";

export class SnsCardPreviewPlaceholderRender {
    public static buildNoImagePlaceholderInnerHtml(): string {
        return `
            <div class="placeholder-icon text-icon"><i class="bi bi-paperclip"></i></div>
            <div class="placeholder-text final-placeholder">${Placeholders.NO_IMAGE}</div>
        `;
    }

    public static ensureNoImagePlaceholderInMediaArea(mediaArea: HTMLElement): void {
        if (!(mediaArea instanceof HTMLElement)) return;

        const existing = snsPreviewManagerForm.getBoardMediaPlaceholder(mediaArea);
        if (existing) return;

        const placeholder = document.createElement("div");
        placeholder.className = "board-placeholder";
        placeholder.setAttribute("data-role", Roles.BOARD_MEDIA_PLACEHOLDER);
        placeholder.setAttribute("data-placeholder-variant", "no-image");
        placeholder.innerHTML = this.buildNoImagePlaceholderInnerHtml();
        mediaArea.prepend(placeholder);
    }

    public static renderNoImagePlaceholderTile(tile: HTMLElement): void {
        tile.innerHTML = `<div class="board-placeholder" data-placeholder-variant="no-image">${this.buildNoImagePlaceholderInnerHtml()}</div>`;
    }

    public static renderTextOnlyPlaceholderIcon(placeholderIcon: HTMLElement): void {
        placeholderIcon.innerHTML = '<i class="bi bi-file-text"></i>';
    }
}
